import React, { useState, useEffect } from "react";
import { MdDownloadForOffline } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import { client, urlForImage } from "../client";
import MasonryLayout from "./MasonryLayout";
import { pinDetailMorePinQuery, pinDetailQuery } from "../utils/data";
import Spinner from "./Spinner";

const PinDetail = ({ user }) => {
  const [pins, setPins] = useState(null);
  const [pinDetail, setPinDetail] = useState(null);
  const [comment, setComment] = useState("");
  const [addingComment, setAddingComment] = useState(false);
  const { pinId } = useParams();

  const fetchPinDetails = async () => {
    let query = pinDetailQuery(pinId);
    if (query) {
      try {
        const data = await client.fetch(query);
        setPinDetail(data[0]);
        if (data[0]) {
          query = pinDetailMorePinQuery(data[0]);
          const response = await client.fetch(query);
          setPins(response);
        }
      } catch (err) {
        console.log("Error while fetching Pin detail", err);
      }
    }
  };
  const addComment = async () => {
    try {
      if (comment) {
        setAddingComment(true);
        await client
          .patch(pinId)
          .setIfMissing({ comments: [] })
          .insert("after", "comments[-1]", [
            {
              comment,
              _key: uuidv4,
              postedBy: {
                _type: "postedBy",
                _ref: user._id,
              },
            },
          ])
          .commit({ autoGenerateArrayKeys: true });
        fetchPinDetails();
        setComment("");
        setAddingComment(false);
      }
    } catch (err) {
      console.log("Error adding comment", err);
    }
  };
  useEffect(() => {
    fetchPinDetails();
  }, [pinId]);

  if (!pinDetail) return <Spinner />;
  return (
    <div>
      <div
        className="flex xl:flex-row flex-col m-auto  bg-white "
        style={{ maxWidth: "1500px", borderRadius: "32px" }}
      >
        <div className="flex justify-center items-center md:items-start flex-initial">
          <img
            src={pinDetail.image && urlForImage(pinDetail.image).url()}
            className="rounded-t-3xl rounded-b-lg "
            alt="user-posts"
          />
        </div>
        <div className="w-full p-5 flex-1 xl:min-w-620">
          <div className="flex items-center justify-between ">
            <div className="flex gap-2 items-center">
              <a
                // href={`${image?.asset?.url}?dl=`}
                href={`${pinDetail.image.asset.url}?dl=`}
                download
                onClick={(e) => e.stopPropagation()}
                className="bg-white w-5 h-5 rounded-full flex items-center justify-center text-dark text-xl opacity-75 hover:opacity-100 hover:shadow-md outline-none"
              >
                <MdDownloadForOffline />
              </a>
            </div>
            <a href={pinDetail.destination} target="_blank" rel="noreferer">
              {pinDetail.destination}
            </a>
          </div>
          <div>
            <h1 className="text-4xl font-bold break-words mt-3">
              {pinDetail.title}
            </h1>
            <p className="mt-3">{pinDetail.about}</p>
          </div>
          <Link
            className="flex gap-2 mt-5 items-center bg-white rounded-lg"
            to={`user-profile/${pinDetail.postedBy._id}`}
          >
            <img
              className="w-8 h-8 rounded-full object-cover"
              src={pinDetail.postedBy.image}
            />
            <p className="font font-semibold capitalize ">
              {pinDetail.postedBy.username}
            </p>
          </Link>
          <h2 className="mt-5 text-2xl">Comments</h2>
          <div className="max-h-370 overflow-y-auto">
            {pinDetail.comments &&
              pinDetail.comments.map((comment, i) => (
                <div
                  className="flex gap-2 mt-5 items-center bg-white rounded-l"
                  key={i}
                >
                  <img
                    src={comment.postedBy.image}
                    alt="userProfile"
                    className="w-10 h-10 rounded-full cursor-pointer"
                  />
                  <div className="flex flex-col">
                    <p className="font-bold ">{comment.postedBy.username}</p>
                    <p className="">{comment.comment}</p>
                  </div>
                </div>
              ))}
          </div>
          <div className="flex flex-wrap mt-6 gap-3">
            <Link to={`user-profile/${pinDetail.postedBy._id}`}>
              <img
                className="w-10 h-10 rounded-full cursor-pointer"
                src={pinDetail.postedBy.image}
              />
            </Link>
            <input
              className="flex-1 border-gray-100 outline-none border-2 p-2 rounded-2xl focus:border-gray-300"
              placeholder="Add a commnent"
              onChange={(e) => setComment(e.target.value)}
              value={comment}
            />
            <button
              onClick={addComment}
              type="button"
              className="bg-red-500 text-white rounded-full px-6 py-2 font-semibold text-base outline-none"
            >
              {addingComment ? "Posting the comment" : "Post"}
            </button>
          </div>
        </div>
      </div>
      {pins?.length > 0 ? (
        <>
          <h2 className="text-center font-bold text-2xl mt-8 mb-4 ">
            More like this
          </h2>
          <MasonryLayout pins={pins} />
        </>
      ) : (
        <Spinner message="Loading More pins" />
      )}
    </div>
  );
};

export default PinDetail;
